import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  terminatedTalents: null,
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, sortableColumns, filters } = payload;
  const terminatedTalents = data;

  return {
    ...state,
    terminatedTalents,
    total,
    filters,
    filteredTotal,
    sortableColumns,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
